import { render } from "./AssignInstance.vue?vue&type=template&id=db854064&scoped=true"
import script from "./AssignInstance.vue?vue&type=script&lang=js"
export * from "./AssignInstance.vue?vue&type=script&lang=js"

import "./AssignInstance.vue?vue&type=style&index=0&id=db854064&scoped=true&lang=scss"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db854064"]])

export default __exports__